const M = [
  {
    name: "myInvitationDetails",
    zh: "我的邀请详情",
    en: "My invitation detail"
  },
  {
    name: "accumulated",
    zh: "累计获得",
    en: "Accumulated"
  },
  {
    name: "successfulInvited",
    zh: "成功邀请",
    en: "Successful invited"
  },
  {
    name: "successfulConsumption",
    zh: "成功消费",
    en: "Successful consumption"
  },
  {
    name: "friendsInvitation",
    zh: "接受邀请的好友",
    en: "Friends who received the invitation"
  },
  {
    name: "rulesDescription",
    zh: "规则说明",
    en: "Rules description"
  },
  {
    name: "shareH2",
    zh: "易付宝平台安全、方便、快捷",
    en: "eepay platform is safe, convenient and fast"
  },
  {
    name: "shareH3",
    zh: "业务含盖充值、缴费、外卖",
    en: "Business including recharge, payment and takeout"
  },
  {
    name: "shareH4",
    zh: "快来注册体验吧！",
    en: "Come and register to experience!"
  }
];

export default M;
